import { gql, TypedDocumentNode } from "@apollo/client";
import type { BackgroundCheckOrderActionPayload } from "./types";

const BACKGROUND_CHECK_ORDER_MUTATION_FIELDS = `
  id
  status
  paidAt
  providerId
  awaitingModeration
  staffInvitationCreatable
`;

const BACKGROUND_CHECK_ORDER_ACTION_FIELDS = `
  id
  status
  paidAt
  providerId
  awaitingModeration
  staffInvitationCreatable
  staffInvitationEmailable
  createdAt
  updatedAt
`;

export type CreateBackgroundCheckOrderVariables = {
  personId: string;
};

export const CREATE_BACKGROUND_CHECK_ORDER_MUTATION: TypedDocumentNode<
  { createBackgroundCheckOrder: BackgroundCheckOrderActionPayload },
  CreateBackgroundCheckOrderVariables
> = gql`
  mutation CreateBackgroundCheckOrder($personId: ID!) {
    createBackgroundCheckOrder(personId: $personId) {
      success
      message
      order {
        ${BACKGROUND_CHECK_ORDER_MUTATION_FIELDS}
      }
    }
  }
`;

export type SendBackgroundCheckInvitationEmailVariables = {
  orderId: string;
};

export const SEND_BACKGROUND_CHECK_INVITATION_EMAIL_MUTATION: TypedDocumentNode<
  { sendBackgroundCheckInvitationEmail: BackgroundCheckOrderActionPayload },
  SendBackgroundCheckInvitationEmailVariables
> = gql`
  mutation SendBackgroundCheckInvitationEmail($orderId: ID!) {
    sendBackgroundCheckInvitationEmail(orderId: $orderId) {
      success
      message
      order {
        ${BACKGROUND_CHECK_ORDER_ACTION_FIELDS}
      }
    }
  }
`;
